import { ref } from 'vue';

type Theme = 'light' | 'dark' | 'miri';

const curr = ref<Theme>('light');


const switchToMiriFavicon = () => { // TODO: switch back?
  const link = document.querySelector('link[rel=icon]') as HTMLLinkElement;
  link.href = '/images/cropped-Miri_Technologies_Logo_Color-192x192.webp';

  const applelink = document.querySelector('link[rel="apple-touch-icon"]') as HTMLLinkElement;
  applelink.href = '/images/cropped-Miri_Technologies_Logo_Color-180x180.webp';

  const mslink = document.querySelector('meta[name="msapplication-TileImage"]') as HTMLMetaElement;
  mslink.content = '/images/cropped-Miri_Technologies_Logo_Color-270x270.webp';
};

export const useTheme = () => {
  const use = (theme: Theme) => {
    const map = {
      light: ['dark', 'miri'],
      dark: ['light', 'miri'],
      miri: ['light', 'dark'],
    };
    // primevue, in house light, and miri
    document.documentElement.classList.remove(...map[theme]);
    document.documentElement.classList.add(theme);

    // bootstrap
    const mode = theme === 'dark' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-bs-theme', mode);

    if (theme === 'miri') switchToMiriFavicon()

    curr.value = theme;
  };

  return { use, curr };
};
